module.exports = __webpack_public_path__ + "img/MM2_170_thumb.46fbdaf4.jpg";